import axios from 'axios';

// ✅ 从 URL 中提取参数并存储到 localStorage
function initAuthParams() {
  // 1. 即使 localStorage 有了，也建议判断 URL 是否带了新 token（方便覆盖/切换账号）


  let search = window.location.search;
  let hash = window.location.hash;

  // 2. 核心逻辑：合并处理 search 和 hash 中的参数
  // 这样无论是在 # 前还是在 # 后，都能拿到
  let queryString = "";
  if (search) {
    queryString = search.substring(1);
  } else if (hash && hash.includes('?')) {
    queryString = hash.split('?')[1];
  }

  if (!queryString) return;

  const urlParams = new URLSearchParams(queryString);
  
  // 3. 提取并存储
  const token = urlParams.get('token');
  const baseid = urlParams.get('baseid');
  const year = urlParams.get('year');

  if (token) localStorage.setItem('token', token);
  if (baseid) localStorage.setItem('baseid', baseid);
  if (year) localStorage.setItem('year', year);

  // console.log('初始化认证参数完成:', {
  //   token: token ? token : '保持原样',
  //   baseid: baseid || '未检测到',
  //   year: year || '未检测到'
  // });
}

// ✅ 页面加载时立即执行一次
initAuthParams();

// ✅ 创建 axios 实例
const request = axios.create({
  baseURL: 'https://cloud.nongliankeji.cn',  // 基础地址
  timeout: 10000,  // 请求超时时间
});

// ✅ 请求拦截器
request.interceptors.request.use(
  config => {
    // 从 localStorage 获取 token
    let token = localStorage.getItem('token');
    
    // 设置默认请求头
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // 默认 token（备用）
      config.headers.Authorization = `Bearer eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoxOSwidXNlcl9rZXkiOiIyMzA4ZDVjNy0yYzAxLTRhNzgtYWI1Ny00NGQ3NTIyMWYzYzUiLCJ1c2VybmFtZSI6IueuoeeQhuWRmCJ9.Z-nUB5hu13DP7SQv48bkKloyuyv5-q8pRIp24aV2gCLBqZ4e-B55Q2GbHaambb1TGfrLdCIqMFkkNn19GAG_ew`;
    }
    
    // 设置 baseid（优先使用 localStorage，其次默认值）
    if (!config.headers.baseid) {
      config.headers.baseid = localStorage.getItem('baseid') || '19';
    }
    
    // 设置 year（优先使用 localStorage，其次默认值）
    if (!config.headers.year) {
      config.headers.year = localStorage.getItem('year') || '2026';
    }
    
    // console.log('请求配置:', config);
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// ✅ 响应拦截器
request.interceptors.response.use(
  response => {
    // console.log('响应数据:', response);
    return response;
  },
  error => {
    console.error('响应错误:', error);
    
    // 处理 401 未授权
    if (error.response && error.response.status === 401) {
      console.error('未授权，请重新登录');
      // 可以在这里跳转登录页
    }
    
    // 处理 404 未找到
    if (error.response && error.response.status === 404) {
      console.error('请求资源不存在');
    }
    
    // 处理 500 服务器错误
    if (error.response && error.response.status === 500) {
      console.error('服务器错误');
    }
    
    return Promise.reject(error);
  }
);

/**
 * 封装 GET 请求
 * @param {string} url - 请求路径
 * @param {object} params - 请求参数
 * @param {object} headers - 自定义请求头
 * @returns {Promise}
 */
export function get(url, params = {}, headers = {}) {
  return request({
    method: 'get',
    url,
    params,
    headers: {
      ...headers,
    },
  });
}

/**
 * 封装 POST 请求
 * @param {string} url - 请求路径
 * @param {object} data - 请求体数据
 * @param {object} headers - 自定义请求头
 * @returns {Promise}
 */
export function post(url, data = {}, headers = {}) {
  return request({
    method: 'post',
    url,
    data,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  });
}

/**
 * 封装 PUT 请求
 * @param {string} url - 请求路径
 * @param {object} data - 请求体数据
 * @param {object} headers - 自定义请求头
 * @returns {Promise}
 */
export function put(url, data = {}, headers = {}) {
  return request({
    method: 'put',
    url,
    data,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  });
}

/**
 * 封装 DELETE 请求
 * @param {string} url - 请求路径
 * @param {object} params - 请求参数
 * @param {object} headers - 自定义请求头
 * @returns {Promise}
 */
export function del(url, params = {}, headers = {}) {
  return request({
    method: 'delete',
    url,
    params,
    headers: {
      ...headers,
    },
  });
}

// ✅ 导出清除认证信息的方法（用于退出登录）
export function clearAuthParams() {
  localStorage.removeItem('token');
  localStorage.removeItem('baseid');
  localStorage.removeItem('year');
}

// ✅ 导出设置认证信息的方法（用于手动更新）
export function setAuthParams({ token, baseid, year }) {
  if (token) localStorage.setItem('token', token);
  if (baseid) localStorage.setItem('baseid', baseid);
  if (year) localStorage.setItem('year', year);
}

export default request;